<template>
  <v-menu offset-y>
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" variant="text" size="small">
        <v-icon class="mr-1">mdi-translate</v-icon>
        {{ currentLanguageLabel }}
        <v-icon end>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="lang in availableLanguages"
        :key="lang.code"
        @click="selectLanguage(lang.code)"
        :class="{ 'bg-primary': currentLanguage === lang.code }"
      >
        <v-list-item-title>
          <span class="mr-2">{{ lang.flag }}</span>
          {{ lang.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { changeLanguage } from "@/composables/useLanguages";

export default {
  name: "LanguageSelector",
  data() {
    return {
      currentLanguage: 'ro',
      availableLanguages: [
        { code: 'ro', name: 'Romana', flag: '🇷🇴' },
        { code: 'en', name: 'English', flag: '🇬🇧' },
        { code: 'fr', name: 'Francais', flag: '🇫🇷' },
        { code: 'ge', name: 'Deutsch', flag: '🇩🇪' },
        { code: 'sp', name: 'Espanol', flag: '🇪🇸' },
        { code: 'it', name: 'Italiano', flag: '🇮🇹' },
        { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
        { code: 'bg', name: 'Bulgarian', flag: '🇧🇬' },
        { code: 'ru', name: 'Russian', flag: '🇷🇺' },
        { code: 'tr', name: 'Turkish', flag: '🇹🇷' },
      ]
    }
  },
  computed: {
    currentLanguageLabel() {
      const lang = this.availableLanguages.find(l => l.code === this.currentLanguage);
      return lang ? `${lang.flag} ${lang.code.toUpperCase()}` : 'RO';
    }
  },
  methods: {
    selectLanguage(code) {
      this.currentLanguage = code;
      changeLanguage(code);
      localStorage.setItem('selectedLanguage', code);
    }
  },
  created() {
    const savedLang = localStorage.getItem('selectedLanguage');
    if (savedLang) {
      this.currentLanguage = savedLang;
      changeLanguage(savedLang);
    }
  }
}
</script>
